<template>
  <b-row class="mt-4">
    <b-col cols="12" md="6">
      <questions-card
        ref="questionCard"
        @getQuestionsList="setQuestionsList"
        class="custom-question-card"
      ></questions-card>
    </b-col>
    <b-col cols="12" md="6">
      <exam-card
        :questionsList="questionsList"
        class="custom-question-card"
      ></exam-card>
    </b-col>
    <b-col cols="12">
      <div class="w-100 d-flex justify-content-end">
        <b-button variant="success" @click="createExamQuestions">
          ایجاد آزمون
        </b-button>
      </div>
    </b-col>
  </b-row>
</template>
<script>
export default {
  emits: ["getExamQuestions"],
  data() {
    return {
      questionsList: null,
    };
  },
  methods: {
    resetQuestions() {
      this.$refs.questionCard.resetList();
      this.questionsList = [];
    },
    setQuestionsList(questionsList) {
      this.questionsList = questionsList;
    },
    createExamQuestions() {
      const examQuestions = [];
      this.questionsList.forEach((item) => {
        examQuestions.push({
          isDeleted: false,
          examQuestionId: 0,
          examId: 0,
          questionId: item.questionId,
          createDate: new Date(Date.now()),
          questionInfo: item,
        });
      });
      this.$emit("getExamQuestions", examQuestions);
    },
  },
  components: {
    BButton,
    BRow,
    BCol,
    QuestionsCard,
    ExamCard,
  },
};
import { BRow, BCol, BButton } from "bootstrap-vue";

import QuestionsCard from "@/views/components/Exams/QuestionsCard.vue";
import ExamCard from "@/views/components/Exams/ExamCard.vue";
</script>
<style>
.custom-question-card {
  min-height: 720px;
  max-height: 720px;
  overflow-y: auto;
}
</style>
